module.exports = {
  termsAndConditions: '/public/docs/TermsAndConditions.pdf',
  privacyNotice: '/public/docs/PrivacyNotice.pdf',
  policy: '/public/docs/policy.html',
  personalData: '/public/docs/PersonalData.pdf',
};
